<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="custom-popup" style="width: 400px;">
    <div class="popup-header" style="width: 400px;">
      <h3><span class="moderat-meGreen-bold">{{ popupData.site_name }}</span></h3>
    </div>
    <div class="line-312">
        <svg style="width: 100%; height: 1px;">
            <use href="@/assets/svg/newSvgIcon.svg#line312"></use>
        </svg>
      </div>
    <div class="popup-body" style="width: 400px;">
      <p class="moderat-meGreen-bold">{{ popupData.state.toUpperCase() }}</p>
      <div class="availability">
        <div class="indicator"></div>
        <span>
          <span class="moderat-meGreen-12">{{
            popupData.chargers_count == 1
              ? "1 Charger"
              : popupData.chargers_count + " Chargers"
          }}
          Available</span>
        </span>
      </div>
    </div>
    <div class="line-312">
        <svg style="width: 100%; height: 1px;">
            <use href="@/assets/svg/newSvgIcon.svg#line312"></use>
        </svg>
      </div>
    <div class="chargers" v-if="showCharger" :v-loading="loading" style="width: 400px;">
      <table class="styled-table w-100">
        <thead>
          <tr>
            <th><span class="moderat-white-bold-12">ChargerID</span></th>
            <th><span class="moderat-white-bold-12">Capacity</span></th>
            <th><span class="moderat-white-bold-12">Type</span></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in tableData" :key="i">
            <td><span class="moderat-meGreen-12">{{ item.charger_name }}</span></td>
            <td><span class="moderat-meGreen-12">{{ item.charger_capacity_kW }}</span></td>
            <td><span class="moderat-meGreen-12">{{ item.charger_type }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="popup-footer">
      <el-button
        @click="handleClick"
        class="view-more"
        link
        style="cursor: pointer"
      >
        {{ showCharger ? "View less" : "View more" }}
      </el-button>
    </div>
  </div>
</template>

<script>
import UserService from "../../../services/user.service";
export default {
  props: {
    popupData: Object,
  },
  data() {
    return {
      loading: false,
      showCharger: false,
      tableData: [],
    };
  },
  methods: {
    handleClick() {
      this.showCharger = !this.showCharger;
      if (this.showCharger) this.fetchAllChargingSite();
    },
    fetchAllChargingSite() {
      let filter = {
        charging_site_id: this.popupData.charger_site_id,
        customer_id: null,
      };
      this.loading = true;
      UserService.GetChargerList(filter, 1, 100)
        .then(
          (response) => {
            this.tableData = response.data.chargers;
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

